<template>
    <div class="container">
        <md-dialog :md-active.sync="showNewAjuste" :md-click-outside-to-close="false" class="custom-dialog">
            <md-dialog-title class="dialog-header text-center">
                {{ f_titulo() }}
            </md-dialog-title>
            <md-dialog-content class="dialog-content">
                <!-- ORIGEN -->
                <div class="section-header">
                    <h6>{{ labels.origen }}</h6>
                </div>
                
                <div class="form-group">
                    <div class="form-field">
                        <label class="field-label">{{labels.company}}</label>
                        <md-field class="custom-field">
                            <select v-model="selCompanyOrig" class="modern-select">
                                <option value=""> {{ labels.select }} </option>
                                <option v-for="comp in listCompany" :key="comp.id" :value="comp.id"> 
                                    {{ comp.acronym+'-'+comp.nombre }} 
                                </option>
                            </select>
                        </md-field>
                    </div>
                    
                    <div class="form-field">
                        <label class="field-label">{{labels.eliminacion}}</label>
                        <md-field class="custom-field">
                            <select v-model="selEliminacion" class="modern-select" @change="onEliminacionChange">
                                <option value=""> {{ labels.select }} </option>
                                <option value="1"> {{ labels.intNoContr }} </option>
                                <option value="2"> {{ labels.elimInversion }} </option>
                                <option value="3"> {{ labels.elimSaldoRecip }} </option>
                            </select>
                        </md-field>
                    </div>
                </div>
                
                <div class="form-group">
                    <div class="form-field">
                        <label class="field-label">{{ labels.type }}</label>
                        <md-field class="custom-field">
                            <md-input type="text" v-model="tipoOrig" :placeholder="labels.type" maxlength="100" />
                        </md-field>
                    </div>
                    <div class="form-field"></div> 
                </div>
                
                <div v-if="showCuentaOrig && selEliminacion !== ''" class="accounts-section">
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{labels.criterio}}</label>
                            <div class="search-fields">
                                <md-field class="custom-field search-field">
                                    <md-input type="text" v-model="critCuenta" @input="buscaCuenta" 
                                            :placeholder="labels.account + '...'" />
                                </md-field>
                                <md-field class="custom-field search-field">
                                    <md-input type="text" v-model="critDescripcion" @input="buscaDescripcion" 
                                            :placeholder="'Descripción...'" />
                                </md-field>
                            </div>
                        </div>
                        
                        <div class="form-field">
                            <label class="field-label">{{labels.account}}</label>
                            <div class="selection-info">
                                <span class="badge-info">
                                    {{ labels.selected }}: {{ listadoCuentasOrig.length }}
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="accounts-container">
                        <div class="select-all-container" v-if="listCuentasSelMul.length > 0">
                            <md-checkbox v-model="selectAllOrig" @change="toggleSelectAllOrig" class="custom-checkbox">
                                {{ labels.selectAll }}
                            </md-checkbox>
                        </div>
                        
                        <div class="accounts-table-container" v-if="listCuentasSelMul.length > 0">
                            <table class="accounts-table">
                                <thead>
                                    <tr>
                                        <th class="checkbox-column"></th>
                                        <th class="account-column">{{ labels.account }}</th>
                                        <th class="desc-column">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cuenta,idx) in listCuentasSelMul" :key="idx+'-'+cuenta.id">
                                        <td class="checkbox-column">
                                            <md-checkbox v-model="cuenta._selected" 
                                                       @change="onAccountChange(cuenta, 'orig')"
                                                       class="custom-checkbox" />
                                        </td>
                                        <td class="account-column">{{ cuenta.cuenta }}</td>
                                        <td class="desc-column" :title="cuenta.descripcion">
                                            {{ cuenta.descripcion }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div v-else-if="selCompanyOrig && !loadingCuentas" class="no-results">
                            {{ labels.noAccountsFound }}
                        </div>
                        <div v-else-if="loadingCuentas" class="loading-state">
                            <div class="spinner-border spinner-border-sm mr-2" role="status"></div>
                            {{ labels.loading }}
                        </div>
                    </div>
                </div>

                <!-- DESTINO - SOLO PARA ELIMINACION 2 Y 3 -->
                <div v-if="showDestino && (selEliminacion === '2' || selEliminacion === '3')" class="section-header mt-4">
                    <h6>{{ labels.destino }}</h6>
                </div>
                
                <div v-if="showDestino && (selEliminacion === '2' || selEliminacion === '3')" class="form-group">
                    <div class="form-field">
                        <label class="field-label">{{labels.company}}</label>
                        <md-field class="custom-field">
                            <select v-model="selCompanyDest" class="modern-select">
                                <option value=""> {{ labels.select }} </option>
                                <option v-for="comp in listCompany" :key="comp.id" :value="comp.id"> 
                                    {{ comp.acronym + '-' + comp.nombre }} 
                                </option>
                            </select>
                        </md-field>
                    </div>
                    
                    <div class="form-field">
                        <label class="field-label">{{ labels.type }}</label>
                        <md-field class="custom-field">
                            <md-input type="text" v-model="tipoDest" :placeholder="labels.type" maxlength="100" />
                        </md-field>
                    </div>
                </div>
                
                <!-- CUENTAS DESTINO CON CHECKBOXES - SOLO PARA ELIMINACION 2 Y 3 -->
                <div v-if="showCuentaDest && (selEliminacion === '2' || selEliminacion === '3')" class="accounts-section">
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{labels.criterio}}</label>
                            <div class="search-fields">
                                <md-field class="custom-field search-field">
                                    <md-input type="text" v-model="critCuentaDest" @input="buscaCuentaDest" 
                                            :placeholder="labels.account + '...'" />
                                </md-field>
                                <md-field class="custom-field search-field">
                                    <md-input type="text" v-model="critDescripcionDest" @input="buscaDescripcionDest" 
                                            :placeholder="'Descripción...'" />
                                </md-field>
                            </div>
                        </div>
                        
                        <div class="form-field">
                            <label class="field-label">{{labels.account}}</label>
                            <div class="selection-info">
                                <span class="badge-info">
                                    {{ labels.selected }}: {{ listadoCuentasDest.length }}
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <div class="accounts-container">
                        <div class="select-all-container" v-if="listCuentasSelMulDest.length > 0">
                            <md-checkbox v-model="selectAllDest" @change="toggleSelectAllDest" class="custom-checkbox">
                                {{ labels.selectAll }}
                            </md-checkbox>
                        </div>
                        
                        <div class="accounts-table-container" v-if="listCuentasSelMulDest.length > 0">
                            <table class="accounts-table">
                                <thead>
                                    <tr>
                                        <th class="checkbox-column"></th>
                                        <th class="account-column">{{ labels.account }}</th>
                                        <th class="desc-column">{{ labels.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cuenta,idx) in listCuentasSelMulDest" :key="idx+'-'+cuenta.id">
                                        <td class="checkbox-column">
                                            <md-checkbox v-model="cuenta._selected" 
                                                       @change="onAccountChange(cuenta, 'dest')"
                                                       class="custom-checkbox" />
                                        </td>
                                        <td class="account-column">{{ cuenta.cuenta }}</td>
                                        <td class="desc-column" :title="cuenta.descripcion">
                                            {{ cuenta.descripcion }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div v-else-if="selCompanyDest && !loadingCuentasDest" class="no-results">
                            {{ labels.noAccountsFound }}
                        </div>
                        <div v-else-if="loadingCuentasDest" class="loading-state">
                            <div class="spinner-border spinner-border-sm mr-2" role="status"></div>
                            {{ labels.loading }}
                        </div>
                    </div>
                </div>
                
                <md-dialog-actions class="dialog-actions mt-3">
                    <md-button class="md-raised md-primary save-btn" @click="guardaAjuste">{{ labels.save }}</md-button>
                    <md-button class="md-raised cancel-btn" @click="closeModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import Company from '../../services/Company'
import PlanCuentas from '../../services/PlanCuentas'
import BalanceNiif from '../../services/BalanceNiif'

export default {
    name:"NewAjuste",
    props:['showNewAjuste','vigenciaSelect','codReporte'],
    data: () => ({
        // Datos origen
        selCompanyOrig : "",
        listCompany : [],
        showCuentaOrig : false,
        listCuentasOrig : [],
        listCuentasSelMul : [],
        tipoOrig : "",
        loadingCuentas: false,
        
        // Datos destino
        selCompanyDest : "",
        showCuentaDest : false,
        listCuentasDest : [],
        listCuentasSelMulDest : [],
        tipoDest : "",
        loadingCuentasDest: false,
        
        // Estado general
        showDestino : false,
        selEliminacion : "",
        
        // Filtros
        critCuenta : "",
        critDescripcion : "",
        critCuentaDest : "",
        critDescripcionDest : "",
        
        // Checkboxes
        selectAllOrig: false,
        selectAllDest: false,
        listadoCuentasOrig: [],
        listadoCuentasDest: []
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Ajuste",
                    save : "Guardar",
                    close : "Cerrar",
                    select : "Seleccione...",
                    company : "Compañía:",
                    account : "Cuentas:",
                    description : "Descripción",
                    criterio : "Criterio:",
                    type : "Tipo:",
                    origen : "ORIGEN",
                    destino : "DESTINO",
                    eliminacion : "Eliminación:",
                    intNoContr : "Interes no controlante",
                    elimInversion : "Eliminación en inversión",
                    elimSaldoRecip : "Eliminación saldo recíproco",
                    selected: "Seleccionadas",
                    selectAll: "Seleccionar todas",
                    noAccountsFound: "No se encontraron cuentas",
                    loading: "Cargando cuentas..."
                }
            }else{
                return {
                    title : "New setting",
                    save : "Save",
                    close : "Close",
                    select : "Select...",
                    company : "Company:",
                    account : "Accounts:",
                    description : "Description",
                    criterio : "Criterion:",
                    type : "Type:",
                    origen : "ORIGIN",
                    destino : "DESTINATION",
                    eliminacion : "Elimination:",
                    intNoContr : "Non-controlling interest",
                    elimInversion : "Elimination in investment",
                    elimSaldoRecip : "Reciprocal balance elimination",
                    selected: "Selected",
                    selectAll: "Select all",
                    noAccountsFound: "No accounts found",
                    loading: "Loading accounts..."
                }
            }
        }
    },
    methods:{
        onEliminacionChange() {
            console.log('Eliminación cambiada a:', this.selEliminacion);

            this.showDestino = (this.selEliminacion === '2' || this.selEliminacion === '3');

            if (this.selEliminacion === '1') {
                this.selCompanyDest = "";
                this.showCuentaDest = false;
                this.listCuentasDest = [];
                this.listCuentasSelMulDest = [];
                this.listadoCuentasDest = [];
                this.tipoDest = "";
                this.selectAllDest = false;

                if (this.selCompanyOrig) {
                    this.loadCuentas(this.selCompanyOrig, 'orig');
                }
            } else if (this.selEliminacion === '2' || this.selEliminacion === '3') {
                if (this.selCompanyOrig) {
                    this.loadCuentas(this.selCompanyOrig, 'orig');
                }
            } else {
                this.showCuentaOrig = false;
                this.listCuentasOrig = [];
                this.listCuentasSelMul = [];
                this.listadoCuentasOrig = [];
            }
        },
        
        buscaCuenta(){
            if(this.critCuenta.length == 0) {
                this.listCuentasSelMul = [...this.listCuentasOrig];
                return;
            }
            
            const criterio = "^" + this.critCuenta;
            this.listCuentasSelMul = this.listCuentasOrig.filter(
                (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
            );
            this.updateSelectAll('orig');
        },
        
        buscaDescripcion(){
            if(this.critDescripcion.length == 0) {
                this.listCuentasSelMul = [...this.listCuentasOrig];
                return;
            }
            
            const searchTerm = this.critDescripcion.toUpperCase();
            this.listCuentasSelMul = this.listCuentasOrig.filter(
                (cuenta) => cuenta.descripcion && 
                           cuenta.descripcion.toUpperCase().includes(searchTerm)
            );
            this.updateSelectAll('orig');
        },
        
        buscaCuentaDest(){
            if(this.critCuentaDest.length == 0) {
                this.listCuentasSelMulDest = [...this.listCuentasDest];
                return;
            }
            
            const criterio = "^" + this.critCuentaDest;
            this.listCuentasSelMulDest = this.listCuentasDest.filter(
                (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
            );
            this.updateSelectAll('dest');
        },
        
        buscaDescripcionDest(){
            if(this.critDescripcionDest.length == 0) {
                this.listCuentasSelMulDest = [...this.listCuentasDest];
                return;
            }
            
            const searchTerm = this.critDescripcionDest.toUpperCase();
            this.listCuentasSelMulDest = this.listCuentasDest.filter(
                (cuenta) => cuenta.descripcion && 
                           cuenta.descripcion.toUpperCase().includes(searchTerm)
            );
            this.updateSelectAll('dest');
        },
        
        // Métodos para checkboxes
        toggleSelectAllOrig() {
            this.listCuentasSelMul.forEach(cuenta => {
                cuenta._selected = this.selectAllOrig;
                if (this.selectAllOrig && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                    this.listadoCuentasOrig.push(cuenta.cuenta);
                } else if (!this.selectAllOrig) {
                    const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta);
                    if (index > -1) {
                        this.listadoCuentasOrig.splice(index, 1);
                    }
                }
            });
        },
        
        toggleSelectAllDest() {
            this.listCuentasSelMulDest.forEach(cuenta => {
                cuenta._selected = this.selectAllDest;
                if (this.selectAllDest && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                    this.listadoCuentasDest.push(cuenta.cuenta);
                } else if (!this.selectAllDest) {
                    const index = this.listadoCuentasDest.indexOf(cuenta.cuenta);
                    if (index > -1) {
                        this.listadoCuentasDest.splice(index, 1);
                    }
                }
            });
        },
        
        onAccountChange(cuenta, type) {
            if (type === 'orig') {
                if (cuenta._selected && !this.listadoCuentasOrig.includes(cuenta.cuenta)) {
                    this.listadoCuentasOrig.push(cuenta.cuenta);
                } else if (!cuenta._selected) {
                    const index = this.listadoCuentasOrig.indexOf(cuenta.cuenta);
                    if (index > -1) {
                        this.listadoCuentasOrig.splice(index, 1);
                    }
                }
                this.updateSelectAll('orig');
            } else {
                if (cuenta._selected && !this.listadoCuentasDest.includes(cuenta.cuenta)) {
                    this.listadoCuentasDest.push(cuenta.cuenta);
                } else if (!cuenta._selected) {
                    const index = this.listadoCuentasDest.indexOf(cuenta.cuenta);
                    if (index > -1) {
                        this.listadoCuentasDest.splice(index, 1);
                    }
                }
                this.updateSelectAll('dest');
            }
        },
        
        updateSelectAll(type) {
            if (type === 'orig') {
                if (this.listCuentasSelMul.length === 0) {
                    this.selectAllOrig = false;
                    return;
                }
                this.selectAllOrig = this.listCuentasSelMul.every(cuenta => cuenta._selected);
            } else {
                if (this.listCuentasSelMulDest.length === 0) {
                    this.selectAllDest = false;
                    return;
                }
                this.selectAllDest = this.listCuentasSelMulDest.every(cuenta => cuenta._selected);
            }
        },
        
        
        async guardaAjuste(){
            
            if(this.selEliminacion === "2" || this.selEliminacion === "3"){
                if(!this.selCompanyOrig){
                    this.$toast.error('Diligenciar la compañía origen');
                    return;
                }
                if(this.listadoCuentasOrig.length === 0){
                    this.$toast.error('Seleccionar la(s) cuenta(s) origen');
                    return;
                }
                if(!this.tipoOrig){
                    this.$toast.error('Diligenciar el tipo origen');
                    return;
                }
                if(!this.selCompanyDest){
                    this.$toast.error('Diligenciar la compañía destino');
                    return;
                }
                if(this.listadoCuentasDest.length === 0){
                    this.$toast.error('Seleccionar la(s) cuenta(s) destino');
                    return;
                }
                if(!this.tipoDest){
                    this.$toast.error('Diligenciar el tipo destino');
                    return;
                }
                
                let formOrig = {
                    'vigencia' : this.vigenciaSelect,
                    'codReporte' : this.codReporte,
                    'idCompany' : this.selCompanyOrig,
                    'tipo' : this.tipoOrig,
                    'cuenta' : this.listadoCuentasOrig,
                    'eliminacion' : this.selEliminacion,
                    'idCompanyDest' : this.selCompanyDest,
                    'tipoDest' : this.tipoDest,
                    'cuentaDest' : this.listadoCuentasDest,
                    'idUser' : this.$store.state.userId
                };

                this.saveAdjustment(formOrig);
            } else if(this.selEliminacion === "1") {
                if(!this.selCompanyOrig){
                    this.$toast.error('Diligenciar la compañía origen');
                    return;
                }
                if(!this.tipoOrig){
                    this.$toast.error('Diligenciar el tipo');
                    return;
                }
                
                let formOrig = {
                    'vigencia' : this.vigenciaSelect,
                    'codReporte' : this.codReporte,
                    'idCompany' : this.selCompanyOrig,
                    'tipo' : this.tipoOrig,
                    'cuenta' : this.listadoCuentasOrig,
                    'eliminacion' : this.selEliminacion,
                    'idUser' : this.$store.state.userId
                };

                this.saveAdjustment(formOrig);
            } else {
                this.$toast.error('Seleccionar tipo de eliminación');
                return;
            }
        },
        
        saveAdjustment(formData) {
            BalanceNiif.ingresaElimAjusteOrig(formData)
            .then((res) => {
                if(res.status == 200) {
                    this.$toast.success(res.status + " " + res.data.message);
                } else {
                    this.$toast.error("Error " + res.status + " al grabar");
                }
            })
            .catch((err) => {
                console.log(err);
                this.$toast.error("Error al guardar el ajuste");
            })
            .finally(() => {
                setTimeout(() => {
                    this.reloadTbl();
                }, 1500);
            });
        },
        
        reloadTbl(){
            this.resetForm();
            this.$emit('reloadTbl', this.codReporte, this.vigenciaSelect);
        },
        
        resetForm() {
            this.selCompanyOrig = "";
            this.showCuentaOrig = false;
            this.listCuentasOrig = [];
            this.listCuentasSelMul = [];
            this.listadoCuentasOrig = [];
            this.tipoOrig = "";
            this.selectAllOrig = false;
            this.loadingCuentas = false;
            
            this.selCompanyDest = "";
            this.showCuentaDest = false;
            this.listCuentasDest = [];
            this.listCuentasSelMulDest = [];
            this.listadoCuentasDest = [];
            this.tipoDest = "";
            this.selectAllDest = false;
            this.loadingCuentasDest = false;
            
            this.selEliminacion = "";
            this.showDestino = false;
            
            this.critCuenta = "";
            this.critDescripcion = "";
            this.critCuentaDest = "";
            this.critDescripcionDest = "";
        },
        
        closeModal(){
            this.resetForm();
            this.$emit('closeModal', false);
        },

        f_titulo() {
            return this.$store.state._language == "es-ES" 
                ? "Ajustes de consolidación" 
                : "Consolidation adjustments";
        },
        
        async loadCuentas(idComp, type) {
            console.log('loadCuentas llamado:', idComp, type, 'eliminación:', this.selEliminacion);

            if (!this.selEliminacion) {
                console.log('No cargar cuentas - no hay eliminación seleccionada');
                if (type === 'orig') {
                    this.showCuentaOrig = false;
                    this.listCuentasOrig = [];
                    this.listCuentasSelMul = [];
                } else {
                    this.showCuentaDest = false;
                    this.listCuentasDest = [];
                    this.listCuentasSelMulDest = [];
                }
                return;
            }

            if (type === 'dest' && this.selEliminacion !== '2' && this.selEliminacion !== '3') {
                console.log('No cargar cuentas destino - eliminación no es 2 o 3');
                this.showCuentaDest = false;
                this.listCuentasDest = [];
                this.listCuentasSelMulDest = [];
                return;
            }
            
            if (!idComp) {
                if (type === 'orig') {
                    this.showCuentaOrig = false;
                    this.listCuentasOrig = [];
                    this.listCuentasSelMul = [];
                    this.listadoCuentasOrig = [];
                    this.loadingCuentas = false;
                } else {
                    this.showCuentaDest = false;
                    this.listCuentasDest = [];
                    this.listCuentasSelMulDest = [];
                    this.listadoCuentasDest = [];
                    this.loadingCuentasDest = false;
                }
                return;
            }
            
            if (type === 'orig') {
                this.loadingCuentas = true;
            } else {
                this.loadingCuentasDest = true;
            }
            
            try {
                const res = await PlanCuentas.getCuentasPorCompaVigRepor(
                    idComp, 
                    this.vigenciaSelect, 
                    this.codReporte
                );
                
                console.log('Respuesta del servicio para', type, ':', res.data);
                
                const cuentas = res.data.planCuentas || [];
                console.log('Cuentas recibidas:', cuentas.length, 'para', type);
                
                cuentas.forEach(cuenta => {
                    cuenta._selected = false;
                });
                
                if (type === 'orig') {
                    this.listCuentasOrig = cuentas;
                    this.listCuentasSelMul = [...cuentas];
                    this.showCuentaOrig = true;
                    this.listadoCuentasOrig = [];
                    this.selectAllOrig = false;
                } else {
                    this.listCuentasDest = cuentas;
                    this.listCuentasSelMulDest = [...cuentas];
                    this.showCuentaDest = true;
                    this.listadoCuentasDest = [];
                    this.selectAllDest = false;
                }
                
            } catch (err) {
                console.error('Error cargando cuentas para', type, ':', err);
                if (err.response && err.response.status === 400) {
                    this.$toast.warning(`La compañía seleccionada no tiene cuentas disponibles para el reporte ${this.codReporte} y vigencia ${this.vigenciaSelect}`);
                }
                
                if (type === 'orig') {
                    this.showCuentaOrig = false;
                    this.listCuentasOrig = [];
                    this.listCuentasSelMul = [];
                } else {
                    this.showCuentaDest = false;
                    this.listCuentasDest = [];
                    this.listCuentasSelMulDest = [];
                }
            } finally {
                if (type === 'orig') {
                    this.loadingCuentas = false;
                } else {
                    this.loadingCuentasDest = false;
                }
            }
        }
    },
    mounted(){
        Company.getAllCompanies()
        .then((result) => {
            this.listCompany = result.data.companies || [];
        })
        .catch((error) => {
            console.error('Error cargando compañías:', error);
            this.listCompany = [];
        });
    },
    watch:{
        selCompanyOrig(idComp) {
            console.log('Compañía origen cambiada a:', idComp);
            if (this.selEliminacion) {
                this.loadCuentas(idComp, 'orig');
            } else {
                this.showCuentaOrig = false;
                this.listCuentasOrig = [];
                this.listCuentasSelMul = [];
            }
        },
        
        selCompanyDest(idComp){
            console.log('Compañía destino cambiada a:', idComp);
            if (this.selEliminacion === '2' || this.selEliminacion === '3') {
                this.loadCuentas(idComp, 'dest');
            } else {
                this.showCuentaDest = false;
                this.listCuentasDest = [];
                this.listCuentasSelMulDest = [];
            }
        },
        
        selEliminacion(newVal, oldVal) {
            console.log('Eliminación cambiada de', oldVal, 'a', newVal);
            this.onEliminacionChange();
        }
    }
}
</script>

<style scoped>
/* Estilos base */
.container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.custom-dialog {
    max-width: 900px;
    width: 90%;
    margin: 0 auto;
}

.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    border-bottom: 1px solid #2c3e50;
    text-align: center;
}

.dialog-header h6 {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.dialog-content {
    padding: 20px 24px;
    max-height: 80vh;
    overflow-y: auto;
}

.section-header {
    background: #f8f9fa;
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 20px;
    border-left: 4px solid #3498db;
}

.section-header h6 {
    margin: 0;
    color: #2c3e50;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Formulario */
.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.form-field {
    margin-bottom: 16px;
}

.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.custom-field {
    margin: 0;
}

.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Campos de búsqueda */
.search-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.search-field {
    margin: 0;
}

.selection-info {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.badge-info {
    background-color: #3498db;
    color: white;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 12px;
    font-weight: 600;
}

/* Sección de cuentas */
.accounts-section {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 20px;
}

.accounts-container {
    margin-top: 16px;
}

.select-all-container {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #dee2e6;
}

/* Tabla de cuentas */
.accounts-table-container {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background: white;
}

.accounts-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.accounts-table thead {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #34495e;
}

.accounts-table th {
    color: white;
    padding: 8px 4px;
    text-align: left;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 2px solid #2c3e50;
}

.accounts-table td {
    padding: 4px 4px;
    border-bottom: 1px solid #e9ecef;
    line-height: 1.2;
    vertical-align: middle;
    height: 32px;
}

.accounts-table tr:hover {
    background: #f8f9fa;
}

/* Columnas específicas */
.checkbox-column {
    width: 40px;
    text-align: center;
    padding: 0 2px;
}

.account-column {
    width: 100px;
    font-weight: 600;
    color: #2c3e50;
    text-align: left;
}

.desc-column {
    width: auto;
    min-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

/* Checkboxes personalizados */
.custom-checkbox {
    margin: 0;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container) {
    background: #3498db !important;
    border-color: #3498db !important;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container::after) {
    border-color: white !important;
}

/* Estados */
.no-results {
    padding: 20px;
    text-align: center;
    color: #6c757d;
    font-style: italic;
    font-size: 14px;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.loading-state {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #6c757d;
    font-size: 14px;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.spinner-border {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
    border: 0.2em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spinner-border .75s linear infinite;
}

@keyframes spinner-border {
    to { transform: rotate(360deg); }
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #f8f9fa;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 8px 16px;
    min-width: 90px;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 8px 16px;
    min-width: 90px;
}

.save-btn:hover {
    background: #2980b9 !important;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

/* Scroll personalizado */
.accounts-table-container::-webkit-scrollbar {
    width: 6px;
}

.accounts-table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.accounts-table-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.accounts-table-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.dialog-content::-webkit-scrollbar {
    width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.dialog-content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Tooltips para texto cortado */
.desc-column:hover::after {
    content: attr(title);
    position: absolute;
    background: #333;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 1000;
    white-space: normal;
    max-width: 300px;
    transform: translateY(-100%);
    margin-top: -5px;
}

/* Responsive */
@media (max-width: 768px) {
    .custom-dialog {
        width: 95%;
        margin: 10px;
    }
    
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .search-fields {
        grid-template-columns: 1fr;
        gap: 8px;
    }
    
    .dialog-actions {
        flex-direction: column;
        gap: 8px;
    }
    
    .save-btn, .cancel-btn {
        width: 100%;
    }
    
    .account-column {
        width: 80px;
    }
    
    .desc-column {
        min-width: 150px;
    }
}

@media (max-width: 480px) {
    .dialog-content {
        padding: 12px 16px;
    }
    
    .accounts-table {
        font-size: 12px;
    }
    
    .account-column {
        width: 70px;
    }
    
    .desc-column {
        min-width: 120px;
    }
}
</style>